export default __webpack_public_path__ + "static/media/SG-DarkBlue-0001.c6075c2a.png";